// extracted by mini-css-extract-plugin
module.exports = {"container":"NoteView_container__3JPeF","placeHolderShimmer":"NoteView_placeHolderShimmer__1UnDq","shimmer":"NoteView_shimmer__1Q7cu"};